import { render, staticRenderFns } from "./status-form.vue?vue&type=template&id=ea880eea&scoped=true&"
import script from "./status-form.vue?vue&type=script&lang=js&"
export * from "./status-form.vue?vue&type=script&lang=js&"
import style0 from "./status-form.vue?vue&type=style&index=0&id=ea880eea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea880eea",
  null
  
)

export default component.exports